import { useState } from "react";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";

const Measurements = ({open = false}) => {
  const [showMeasurements, setShowMeasurements] = useState(open);

  return (
    <>
      {showMeasurements && (
        <div className="grid w-[318px]">
          <div className="flex flex-col flex-1 pt-2">
            <div className="flex">
              <h5 className="text-xl font-bold text-teal-300">Measurements</h5>
            </div>
          </div>
        </div>
      )}
      <div className="mx-2 flex justify-center items-center w-[7px] h-auto bg-gray-100">
        {!showMeasurements && (
          <button
            className="rounded-full w-5 h-5 bg-teal-600 mb-[100px]  border-teal-600 text-white inline-flex duration-300 items-center justify-center px-1 py-1"
            onClick={() => {
            setShowMeasurements(true);
            }}
          >
            <ChevronRightIcon className="w-4 h-4 text-white" />
          </button>
        )}
        {showMeasurements && (
          <button
            className="rounded-full w-5 h-5 bg-teal-600 mb-[100px]  border-teal-600 text-white inline-flex duration-300 items-center justify-center px-1 py-1"
            onClick={() => {
            setShowMeasurements(false);
            }}
          >
            <ChevronLeftIcon className="w-4 h-4 text-white" />
          </button>
        )}
      </div>
    </>
  );
};

export default Measurements;
